import React from 'react';
import { useDispatch } from 'react-redux';
import { setPostKyc } from '../../../../store/thunk/setPostKyc';
import Dialog from '@material-ui/core/Dialog';
import {useStyles} from './helper';

const Success = ({accept, setAccept, id}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    return (
        <Dialog maxWidth={600} onClose={() => setAccept(false)} open={accept}>
            <div className={classes.root}>
                <div className={classes.title}>
                    <span>Подтвердите свое действие</span>
                </div>
                <div className={classes.wrapBtn}>
                    <span 
                        className={classes.ok}
                        onClick={() => {
                            dispatch(setPostKyc({
                                    type: 'accept',
                                    id,
                                    description: ''
                            })) 
                            setAccept(false);
                        }}
                    >ОК</span>
                    <span 
                        className={classes.cancel}
                        onClick={() => {
                            setAccept(false)
                        }}
                    >Отмена</span>
                </div>
            </div>
        </Dialog>
    )
}

export default Success;